import React from 'react';

// interface Material {
//   _id: string;
//   title: string;
//   description: string;
//   fileUrl: string;
//   createdBy: string;
//   date: string;
//   moduleId: string;
//   fileType: string; // optional (pdf, video, doc, etc.)
// }

interface MaterialsViewProps {
  material: any;
  onBack: () => void;
}

const MaterialsView: React.FC<MaterialsViewProps> = ({ material, onBack }) => {
  const getFileIcon = (type: string) => {
    switch (type) {
      case 'pdf':
        return '📄';
      case 'video':
        return '🎬';
      case 'doc':
      case 'docx':
        return '📝';
      case 'ppt':
      case 'pptx':
        return '📊';
      default:
        return '📁';
    }
  };

  return (
    <div className="p-6 space-y-6">
      <button
        onClick={onBack}
        className="text-blue-600 hover:underline text-sm"
      >
        ← Back to Materials
      </button>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700 p-6 space-y-4">
        <div className="flex items-center gap-3">
          <span className="text-3xl">{getFileIcon(material.fileType)}</span>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
            {material.title}
          </h2>
        </div>

        <p className="text-gray-700 dark:text-gray-300">{material.description}</p>

        <div className="flex justify-between items-center text-sm text-gray-500">
          <span>By {material.createdBy}</span>
          <span>{material.date}</span>
        </div>

        <div className="text-sm text-gray-500">
          <strong>Module:</strong> {material.moduleId}
        </div>

        <a
          href={material.fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
        >
          Open Material
        </a>
      </div>
    </div>
  );
};

export default MaterialsView;
